import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../../actions/questions.action'
import { getQuestionList } from 'api/administration/questions/List'
import { destroyLikertQuestion } from '../../../../api/administration/questions/Destroy'
import I18n from 'i18n'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'

async function getList(instanceId: number) {
  return await getQuestionList(instanceId)
}

async function destroy(questionId: number) {
  return await destroyLikertQuestion(questionId)
}

function* questionDestroyEffectSaga(action: any) {
  try {
    const {
      payload: { questionId, instanceId },
    } = action
    yield call(destroy, questionId)
    const questionList = yield call(getList, instanceId)
    yield put(fromActions.Actions.questionsListSuccess(questionList))
    SuccessToast(I18n.t('administration.toastMessages.deleteSuccess'))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.deleteError'))
    console.log('error: ', error)
  }
}

export function* questionDestroyLikertWatcherSaga() {
  yield takeLatest(fromActions.QUESTION_LIKERT_DESTROY, questionDestroyEffectSaga)
}
